import { FieldKind } from './date-picker.model';

export interface TokenSpec {
  readonly field: FieldKind;
  readonly width: number;
  readonly min: number;
  readonly max: number;
  readonly placeholder: string;
}

/**
 * Supported pattern tokens. A run of repeated token letters is looked up here as
 * a whole, so `MM` is a token but `MMM` is rejected at compile time.
 */
export const TOKEN_SPECS: Readonly<Record<string, TokenSpec>> = {
  yyyy: { field: 'year', width: 4, min: 1, max: 9999, placeholder: 'YYYY' },
  yy: { field: 'year', width: 2, min: 0, max: 99, placeholder: 'YY' },
  MM: { field: 'month', width: 2, min: 1, max: 12, placeholder: 'MM' },
  dd: { field: 'day', width: 2, min: 1, max: 31, placeholder: 'DD' },
  HH: { field: 'hour24', width: 2, min: 0, max: 23, placeholder: 'HH' },
  hh: { field: 'hour12', width: 2, min: 1, max: 12, placeholder: 'hh' },
  mm: { field: 'minute', width: 2, min: 0, max: 59, placeholder: 'mm' },
  aa: { field: 'dayPeriod', width: 2, min: 0, max: 0, placeholder: '--' },
};

const TOKEN_LETTERS = new Set(['y', 'M', 'd', 'H', 'h', 'm', 'a']);

export const isTokenLetter = (char: string): boolean => TOKEN_LETTERS.has(char);

export const isDigit = (char: string): boolean => char >= '0' && char <= '9';

/** Lower-case first letters of `am` and `pm`, which is all a day period needs typed. */
export const AM_INITIAL = 'a';
export const PM_INITIAL = 'p';

export const isDayPeriodChar = (char: string): boolean => {
  const lower = char.toLowerCase();
  return lower === AM_INITIAL || lower === PM_INITIAL;
};

export const DATE_FIELDS: ReadonlySet<FieldKind> = new Set<FieldKind>(['year', 'month', 'day']);

export const TIME_FIELDS: ReadonlySet<FieldKind> = new Set<FieldKind>([
  'hour24',
  'hour12',
  'minute',
  'dayPeriod',
]);
